<template>
  <div id="ProduktmerkmaleOverview" class="container">
    <b-button class="segmentbutton" block variant="light" v-on:click="collapse" :disabled="collapseDisabled"
              v-b-toggle.collapsePorduktmerkmale>
      <h4 class="float-left"><span id="produktmerkmaleBadge" :class="badgeClass">2</span>
        {{ $t('produktmerkmale-overview.heading') }}</h4>
    </b-button>
    <b-collapse id="collapsePorduktmerkmale" accordion="confiAccordion" role="tabpanel"
                v-on:show="selectDefault">
      <b-card-group columns  v-bind:class="{'card-columns-no3D':(!kunde && !anonym)}">
        <Gruppe v-for="gruppe in gruppen"
                :key="gruppe.id"
                :gruppe="gruppe" v-on:selection-changed="$emit('selection-changed')"/>
      </b-card-group >
      <!-- Back Button -->
      <div class="float-left" style="padding: 0px 0px 10px 0px">
        <b-button :disabled="false" variant="primary" class="mayr-button-blue" href="#"
                  v-b-toggle.collapseTeileauswahl>
          <span>{{ $t('general.back') }}</span>
        </b-button>
      </div>
      <!-- Continue Button -->
      <div class="float-right" style="padding: 0px 0px 10px 0px">
        <b-button :disabled="!isReady" ref="continueMerkmale" :variant="continueButtonVarian"
                  v-bind:class="{ 'mayr-button-blue': isReady, mayrbuttoninactive: !isReady }" href="#"
                  v-b-toggle.collapseProductOverview
                  @click="trackConfigurationComplete()">
          <span>{{ $t('general.continue') }}</span>
        </b-button>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import Gruppe from "./Gruppe";
import isEmpty from "@/mixins/isempty";

import {bus} from '../../../main';
import matomoTracking from "@/mixins/matomoTracking";

export default {
  name: 'ProduktmerkmaleOverview',
  mixins: [isEmpty, matomoTracking],
  components: {Gruppe},
  props: ['gruppen', 'hinweistexte', 'zustand'],
  created() {
    bus.$on('teileauswahl-changed', (isReady) => {
      this.collapseDisabled = isReady;
    })
  },
  data:
      function () {
        return {
          collapsed: false,
          collapseDisabled: true
        }
      },
  computed: {
    isReady: function () {
      if (this.isEmpty(this.$props.gruppen)) {
        //this.$refs.continueMerkmale.click();
        return true;
      }

      return (this.$props.gruppen.every(gruppe => gruppe.attribute.every(attribut =>
              (!this.isEmpty(attribut.selectedEingabeWert) || !this.isEmpty(attribut.selectedAuswahlWert)))) &&
          !this.$store.getters.isValidating);
    },
    badgeClass: function () {
      if (this.isReady) {
        return "badge badge-primary";
      }
      return "badge badge-secondary"
    },
    continueButtonVarian: function () {
      if (this.isReady) {
        return "primary"
      }
      return "secondary"
    },
    anonym: function() {
      return this.$store.getters.getUserData.anonym;
    },
    kunde: function() {
      return this.$store.getters.getUserData.kunde;
    }
  },
  methods: {
    trackConfigurationComplete(){
      this.trackEvent('Konfigurator', 'Produktmerkmale definiert')
    },
    collapse() {
      this.collapsed = !this.collapsed;
      bus.$emit('produktmerkmale-collapsed');
    },
    selectDefault() {
      if (this.$props.zustand !== 'PUBLIC_RELEASE')   // set default values only for public released products
        return;

      this.$props.gruppen.forEach(gruppe => gruppe.attribute.forEach(attribut => {
        if (attribut.selectedEingabeWert !== null) return; //only select default when nothing is selected
        if (attribut.selectedAuswahlWert !== null) return; //only select default when nothing is selected
        if (attribut.name === 'Drehmomenteinstellung') return; // Ausnahme, dies wird nie vorausgewählt, da es derzeit immer nur ein einzelnes Merkmal gibt

        let auswahlWerte = attribut.auswahlWerte.filter(ausWert =>
            ausWert.disabled === false);
        let eingabeWerte = attribut.eingabeWerte.filter(einWert =>
            einWert.disabled === false);
        let vorzugAuswahlWerte = attribut.auswahlWerte.filter(ausWert =>
            ausWert.vorzugswert === true && ausWert.disabled === false);

        if (vorzugAuswahlWerte && vorzugAuswahlWerte.length === 1) {
          attribut.selectedAuswahlWert = vorzugAuswahlWerte[0];
        } else if (auswahlWerte && auswahlWerte.length ===1 && (!eingabeWerte || eingabeWerte.length === 0)) {
          attribut.selectedAuswahlWert = auswahlWerte[0];
        }
      }));
      this.$store.dispatch('validateKonfigModel');
    }
  }
}
</script>

<style scoped>



.mayrbuttoninactive {
  border-radius: 0px;
  background-color: #bfbfbf;
  border:none;
  color: #000
}

</style>